// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__2G0I2","name":"ConsentHeader_name__3Sdu1","birthday":"ConsentHeader_birthday__2mME8","skeleton":"ConsentHeader_skeleton__2pU1_"};